/**
 * @generated SignedSource<<52cb65f940b513bed0a0a0a771011370>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptVideo_updateVideoPlaybackSettingsMutation$variables = {
  muted: boolean;
  playbackRate: number;
  subtitlesEnabled: boolean;
  volume: number;
};
export type TranscriptVideo_updateVideoPlaybackSettingsMutation$data = {
  readonly updateUserVideoPlaybackSettings: {
    readonly userVideoPlaybackSettings: {
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
    };
  } | null;
};
export type TranscriptVideo_updateVideoPlaybackSettingsMutation = {
  response: TranscriptVideo_updateVideoPlaybackSettingsMutation$data;
  variables: TranscriptVideo_updateVideoPlaybackSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "muted"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "playbackRate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subtitlesEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "volume"
},
v4 = [
  {
    "kind": "Variable",
    "name": "muted",
    "variableName": "muted"
  },
  {
    "kind": "Variable",
    "name": "playbackRate",
    "variableName": "playbackRate"
  },
  {
    "kind": "Variable",
    "name": "subtitlesEnabled",
    "variableName": "subtitlesEnabled"
  },
  {
    "kind": "Variable",
    "name": "volume",
    "variableName": "volume"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptVideo_updateVideoPlaybackSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateUserVideoPlaybackSettings",
        "kind": "LinkedField",
        "name": "updateUserVideoPlaybackSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "userVideoPlaybackSettings",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TranscriptVideo_videoPlaybackSettings"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TranscriptVideo_updateVideoPlaybackSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateUserVideoPlaybackSettings",
        "kind": "LinkedField",
        "name": "updateUserVideoPlaybackSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "userVideoPlaybackSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "playbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitlesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "volume",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bff5420f1a782def7ae08f8f5cf4ad4",
    "id": null,
    "metadata": {},
    "name": "TranscriptVideo_updateVideoPlaybackSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptVideo_updateVideoPlaybackSettingsMutation(\n  $playbackRate: Float!\n  $subtitlesEnabled: Boolean!\n  $volume: Float!\n  $muted: Boolean!\n) {\n  updateUserVideoPlaybackSettings(playbackRate: $playbackRate, subtitlesEnabled: $subtitlesEnabled, volume: $volume, muted: $muted) {\n    userVideoPlaybackSettings {\n      ...TranscriptVideo_videoPlaybackSettings\n      id\n    }\n  }\n}\n\nfragment TranscriptVideo_videoPlaybackSettings on UserVideoPlaybackSettings {\n  id\n  playbackRate\n  subtitlesEnabled\n  volume\n  muted\n}\n"
  }
};
})();

(node as any).hash = "bb7f6b70c68bd453afbd45bf880e61d4";

export default node;
